import React from 'react';
import { motion } from 'framer-motion';
// Ensure karein ke Where1.png ka path sahi ho
import Where1 from '../assets/images/Where1.png'; 
import Where2 from '../assets/images/Where2.png'; 

const Where = () => {
  const points = [
    {
      title: "Short Videos & Reels",
      desc: "Share engaging, bite-sized content that keeps everyone entertained.",
      icon: "🎥"
    },
    {
      title: "Smart Notifications",
      desc: "Stay updated on what matters without the noise.",
      icon: "🔔"
    },
    {
      title: "Interest-Based Communities",
      desc: "Join groups and discussions that match your passion.",
      icon: "👥"
    }
  ];

  return (
    <section className="bg-bggraycolor font-avant py-16 lg:py-24 px-6 overflow-hidden">
      <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between gap-16">
        
        {/* LEFT SIDE: ANIMATED PHONES */}
        <div className="w-full lg:w-1/2 relative flex justify-center items-center min-h-[450px]">
          
          {/* Background Solid Circle */}
          <div className="absolute w-[280px] h-[280px] sm:w-[350px] sm:h-[350px] bg-bgcolor rounded-full z-0"></div>

          {/* Left Phone: Automatic Rotation Animation */}
          <motion.div
            animate={{ 
              rotate: [-20, -18, -20], 
              y: [0, 15, 0] 
            }}
            transition={{ 
              duration: 4, 
              repeat: Infinity, 
              ease: "easeInOut" 
            }}
            className="absolute z-10 -translate-x-0 sm:-translate-x-8"
          >
            <img 
              src={Where1} 
              alt="App View 1" 
              className="w-[180px] sm:w-[240px] drop-shadow-2xl rounded-[2.5rem] "
            />
          </motion.div>

          {/* Right Phone: Automatic Rotation Animation */}
          <motion.div
            animate={{ 
              rotate: [15, 12, 15], 
              y: [0, 15, 0] 
            }}
            transition={{ 
              duration: 5, 
              repeat: Infinity, 
              ease: "easeInOut",
              delay: 0.5
            }}
            className="absolute z-20 translate-x-12 sm:translate-x-20"
          >
            <img 
              src={Where2} 
              alt="App View 2" 
              className="w-[200px] sm:w-[260px] drop-shadow-[0_35px_60px_rgba(0,0,0,0.3)] rounded-[2.5rem]"
            />
          </motion.div>
        </div>

        {/* RIGHT SIDE: TEXT & CARDS */}
        <div className="w-full lg:w-1/2 space-y-8">
          <div className="text-center lg:text-left">
            <h2 className="text-4xl md:text-6xl font-bold text-zinc-900 leading-[1.1] mb-6 tracking-tight">
              Where Every Click <br /> Sparks a Connection!
            </h2>
            <p className="text-zinc-500 text-lg max-w-lg mx-auto lg:mx-0 leading-relaxed">
              A small act of kindness today can create a lifetime of impact for someone in need. Give from the heart and change a life!
            </p>
          </div>

          {/* Points Grid */}
          <div className="grid grid-cols-1 gap-5">
            {points.map((point, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.02, x: 5 }}
                className=" p-6 lg:py-8 rounded-[2rem] flex items-center  gap-5 border border-white 
                           shadow-[inset_0_2px_2px_rgba(255,255,255,0.8),_5px_5px_15px_rgba(255,255,255,1),5px_5px_10px_rgba(0,0,0,0.3)]
            transition-all duration-500"
              >
                <div className="text-3xl bg-gray-50 w-14 h-14 flex items-center justify-center rounded-2xl">
                  {point.icon}
                </div>
                <div className="text-left">
                  <h4 className="text-xl font-bold text-zinc-800 tracking-tight">{point.title}</h4>
                  <p className="text-zinc-500 text-sm leading-snug">{point.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Where;